import React from 'react';
import { Button as FuseButton } from '@tvg/fuse/button';
import styles from './Button.module.css';

type Props = React.ComponentPropsWithoutRef<typeof FuseButton>;
type Ref = React.ElementRef<typeof FuseButton>;

const Button = React.forwardRef<Ref, Props>(({ className, ...props }, ref) => (
  <FuseButton ref={ref} className={[styles.button, className].filter(Boolean).join(' ')} {...props} />
));

Button.displayName = 'Button';

export default Button;
